import { TYPE_SERVICE_PRINCIPAL_PROJECT } from 'common/utils/cloud-resource-types';
import BaseServicePrincipalAbility from './service-principal';
import { ACTION_CREATE } from '../utils/permission-types/index';

/**
 * @class ServicePrincipalProjectAbility
 * @extends BaseServicePrincipalAbility
 * @description This class is used to check the permissions for service principal creation at project level.
 */
export default class extends BaseServicePrincipalAbility {
  /** @return {boolean} */
  get canCreate() {
    let principals = this.model || [];
    return (
      this.permissions.has(this.generate(ACTION_CREATE)) &&
      principals.length < this.quota.for(TYPE_SERVICE_PRINCIPAL_PROJECT)
    );
  }

  /** @return {boolean} */
  get canCreateQuotaReached() {
    let principals = this.model || [];
    return principals.length >= this.quota.for(TYPE_SERVICE_PRINCIPAL_PROJECT);
  }
}
